const graysPreset = Object.freeze([
  '#000000', '#1B1B1B', '#333333', '#555555', '#666666', '#898989',
  '#FFFFFF', '#F5F5F5', '#E6E6E6', '#D4D4D4', '#C0C0C0', '#B4B4B4'
]);

const darkPreset = Object.freeze([
  '#F28E2B', '#F9A655', '#FFBE7D', '#B07AA1', '#C290B4', '#D4A6C8',
  '#B6992D', '#D3B348', '#F1CE63', '#D37295', '#E799B3', '#FABFD2',
  '#59A14F', '#72B966', '#8CD17D', '#E15759', '#F17B79', '#FF9D9A',
  '#499894', '#69AAA5', '#86BCB6', '#9D7660', '#BA9582', '#D7B5A6',
  '#4E79A7', '#75A1C7', '#A0CBE8', '#79706E', '#998F8C', '#BAB0AC',
  '#606B76', '#818B91', '#A7ACAD', '#76B7B2', '#FF9DA7', '#EDC948'
]);

const lightPreset = Object.freeze([
  '#EFEBE8', '#F5F1F0', '#F9F8F7', '#F0EAE8', '#F5F0EF', '#FAF5F4',
  '#F5EDDC', '#FAF4E7', '#FEFAF1', '#E9EBE0', '#F0F1E8', '#F7F7F0',
  '#EBEBEB', '#F2F2F2', '#F9F9F9', '#DFE7E8', '#E9F0F1', '#F2F9F9',
  '#F3EBF3', '#F7F1F6', '#FBF7FB', '#E2E6F0', '#E9EDF5', '#F0F3FA',
  '#E6ECF0', '#EEF1F3', '#F2F6F7', '#DDEBF0', '#E7F1F5', '#F0F7FA',
  '#DFEDEB', '#E9F3F2', '#F3FAF9', '#E8EDDA', '#EFF3E3', '#F7FAF0',
  '#F5EAD7', '#F6EEE3', '#FAF5F0', '#F9E9E0', '#F9EEE8', '#F9F3EF'
]);

const maestroFlowPreset = Object.freeze([
  '#4F6980', '#3D7FA6', '#8BC2CA', '#499893',
  '#62AEA1', '#7DC4AE', '#638B66', '#86AF6A',
  '#C3BB3D', '#EFC637', '#F6A035', '#F37941',
  '#F59A9A', '#CD677F', '#C497B7', '#845578',
  '#B9AA98', '#7E756D', '#9EB0A5', '#B56252'
]);

export const ColorPickerPresets = Object.freeze({
  Dark: graysPreset.concat(darkPreset),
  Light: graysPreset.concat(lightPreset),
  MaestroFlowColors: maestroFlowPreset,
});
